export default __webpack_public_path__ + "static/media/Workflow.9013de0c.png";